module.exports = __webpack_public_path__ + "img/Heart.b23bf50c.png";